module.exports = __webpack_public_path__ + "startpage-746fed5a/app-store-badge-de-d91aecf30cb00df9d92dc695a934c27d.svg";